import { EnumPatientInfo } from "../interface/patientRegister.interface"

export const PATIENT_INFO_OPTIONS: Partial<Record<EnumPatientInfo, string>> = {
    [EnumPatientInfo.PatientFirstName]: 'First Name',
    [EnumPatientInfo.PatientMiddleName]: 'Middle Name',
    [EnumPatientInfo.PatientLastName]: 'Last Name',
    [EnumPatientInfo.Date]: 'Date',
    [EnumPatientInfo.Dob]: 'DOB',
    [EnumPatientInfo.PrimaryInsurance]: "Primary Insurance",
    [EnumPatientInfo.PrimaryAuthNumber]: "Auth #",
    [EnumPatientInfo.ParentGuardianName]: "Parent/Guardian Name",
    [EnumPatientInfo.Contact]: "Contact",
    [EnumPatientInfo.Address]: "Address",
    [EnumPatientInfo.Gender]: "Gender",
}
